// extracted by mini-css-extract-plugin
module.exports = {"container":"CKText_container__281k8"};